import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "report-page" }
const _hoisted_2 = { class: "report-header" }
const _hoisted_3 = { class: "container" }
const _hoisted_4 = { class: "page-title" }
const _hoisted_5 = { class: "report-content" }
const _hoisted_6 = { class: "container" }
const _hoisted_7 = { class: "form-section" }
const _hoisted_8 = { class: "section-title" }
const _hoisted_9 = { class: "brand-field" }
const _hoisted_10 = { class: "form-section" }
const _hoisted_11 = { class: "section-title" }
const _hoisted_12 = { class: "form-section" }
const _hoisted_13 = { class: "section-title" }
const _hoisted_14 = { class: "form-section" }
const _hoisted_15 = { class: "section-title" }
const _hoisted_16 = { class: "anonymous-section" }
const _hoisted_17 = { class: "anonymous-label" }
const _hoisted_18 = { class: "anonymous-tip" }
const _hoisted_19 = {
  key: 0,
  class: "contact-fields"
}
const _hoisted_20 = { class: "form-actions" }
const _hoisted_21 = { class: "success-dialog" }
const _hoisted_22 = { class: "success-header" }
const _hoisted_23 = { class: "success-content" }
const _hoisted_24 = { class: "success-message" }
const _hoisted_25 = {
  key: 0,
  class: "case-number"
}
const _hoisted_26 = { class: "qr-section" }
const _hoisted_27 = { class: "qr-title" }
const _hoisted_28 = { class: "qr-description" }
const _hoisted_29 = { class: "qr-code-container" }
const _hoisted_30 = ["src", "alt"]
const _hoisted_31 = { class: "dialog-actions" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NavBar = _resolveComponent("NavBar")!
  const _component_van_field = _resolveComponent("van-field")!
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_van_picker = _resolveComponent("van-picker")!
  const _component_van_popup = _resolveComponent("van-popup")!
  const _component_van_date_picker = _resolveComponent("van-date-picker")!
  const _component_van_switch = _resolveComponent("van-switch")!
  const _component_van_button = _resolveComponent("van-button")!
  const _component_van_form = _resolveComponent("van-form")!
  const _component_van_dialog = _resolveComponent("van-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_NavBar),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h1", _hoisted_4, _toDisplayString(_ctx.$t('report.title')), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_van_form, {
          ref: "formRef",
          class: "report-form",
          onSubmit: $setup.handleSubmit
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("h3", _hoisted_8, _toDisplayString(_ctx.$t('report.brandInfo')), 1),
              _createElementVNode("div", _hoisted_9, [
                _createVNode(_component_van_field, {
                  modelValue: $setup.reportForm.brandName,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.reportForm.brandName) = $event)),
                  label: _ctx.$t('report.brand'),
                  placeholder: _ctx.$t('report.brandPlaceholder'),
                  rules: [{ required: true, message: _ctx.$t('report.brandRequired') }],
                  readonly: "",
                  clickable: "",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.showBrandPicker = true))
                }, null, 8, ["modelValue", "label", "placeholder", "rules"]),
                _createVNode(_component_van_icon, {
                  name: "arrow",
                  class: "field-arrow"
                })
              ]),
              _createVNode(_component_van_popup, {
                show: $setup.showBrandPicker,
                "onUpdate:show": _cache[3] || (_cache[3] = ($event: any) => (($setup.showBrandPicker) = $event)),
                position: "bottom"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_van_picker, {
                    columns: $setup.brandOptions,
                    "show-toolbar": "",
                    title: _ctx.$t('report.selectBrand'),
                    onConfirm: $setup.onBrandConfirm,
                    onCancel: _cache[2] || (_cache[2] = ($event: any) => ($setup.showBrandPicker = false))
                  }, null, 8, ["columns", "title", "onConfirm"])
                ]),
                _: 1
              }, 8, ["show"]),
              _createVNode(_component_van_field, {
                modelValue: $setup.reportForm.productName,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.reportForm.productName) = $event)),
                label: _ctx.$t('report.productName'),
                placeholder: _ctx.$t('report.productNamePlaceholder'),
                rules: [{ required: true, message: _ctx.$t('report.productNameRequired') }]
              }, null, 8, ["modelValue", "label", "placeholder", "rules"])
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("h3", _hoisted_11, _toDisplayString(_ctx.$t('report.purchaseInfo')), 1),
              _createVNode(_component_van_field, {
                modelValue: $setup.reportForm.purchaseChannel,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (($setup.reportForm.purchaseChannel) = $event)),
                label: _ctx.$t('report.purchaseChannel'),
                placeholder: _ctx.$t('report.purchaseChannelPlaceholder'),
                rules: [{ required: true, message: _ctx.$t('report.purchaseChannelRequired') }]
              }, null, 8, ["modelValue", "label", "placeholder", "rules"]),
              _createVNode(_component_van_field, {
                modelValue: $setup.reportForm.purchaseDate,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (($setup.reportForm.purchaseDate) = $event)),
                label: _ctx.$t('report.purchaseDate'),
                placeholder: _ctx.$t('report.purchaseDatePlaceholder'),
                rules: [{ required: true, message: _ctx.$t('report.purchaseDateRequired') }],
                readonly: "",
                clickable: "",
                onClick: _cache[7] || (_cache[7] = ($event: any) => ($setup.showDatePicker = true))
              }, null, 8, ["modelValue", "label", "placeholder", "rules"]),
              _createVNode(_component_van_popup, {
                show: $setup.showDatePicker,
                "onUpdate:show": _cache[10] || (_cache[10] = ($event: any) => (($setup.showDatePicker) = $event)),
                position: "bottom"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_van_date_picker, {
                    modelValue: $setup.currentDate,
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (($setup.currentDate) = $event)),
                    "min-date": $setup.minDate,
                    "max-date": $setup.maxDate,
                    title: _ctx.$t('report.selectDate'),
                    onConfirm: $setup.onDateConfirm,
                    onCancel: _cache[9] || (_cache[9] = ($event: any) => ($setup.showDatePicker = false))
                  }, null, 8, ["modelValue", "min-date", "max-date", "title", "onConfirm"])
                ]),
                _: 1
              }, 8, ["show"])
            ]),
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("h3", _hoisted_13, _toDisplayString(_ctx.$t('report.problemInfo')), 1),
              _createVNode(_component_van_field, {
                modelValue: $setup.reportForm.problemDescription,
                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (($setup.reportForm.problemDescription) = $event)),
                rows: "4",
                autosize: "",
                type: "textarea",
                label: _ctx.$t('report.problemDescription'),
                placeholder: _ctx.$t('report.problemDescriptionPlaceholder'),
                rules: [{ required: true, message: _ctx.$t('report.problemDescriptionRequired') }],
                maxlength: "500",
                "show-word-limit": ""
              }, null, 8, ["modelValue", "label", "placeholder", "rules"])
            ]),
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("h3", _hoisted_15, _toDisplayString(_ctx.$t('report.contactInfo')), 1),
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("span", null, _toDisplayString(_ctx.$t('report.anonymousReport')), 1),
                  _createVNode(_component_van_switch, {
                    modelValue: $setup.reportForm.isAnonymous,
                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (($setup.reportForm.isAnonymous) = $event)),
                    size: "20",
                    onChange: $setup.onAnonymousChange
                  }, null, 8, ["modelValue", "onChange"])
                ]),
                _createElementVNode("p", _hoisted_18, _toDisplayString(_ctx.$t('report.anonymousTip')), 1)
              ]),
              (!$setup.reportForm.isAnonymous)
                ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                    _createVNode(_component_van_field, {
                      modelValue: $setup.reportForm.contactName,
                      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (($setup.reportForm.contactName) = $event)),
                      label: _ctx.$t('report.contactName'),
                      placeholder: _ctx.$t('report.contactNamePlaceholder'),
                      rules: [{ required: !$setup.reportForm.isAnonymous, message: _ctx.$t('report.contactNameRequired') }]
                    }, null, 8, ["modelValue", "label", "placeholder", "rules"]),
                    _createVNode(_component_van_field, {
                      modelValue: $setup.reportForm.contactPhone,
                      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (($setup.reportForm.contactPhone) = $event)),
                      label: _ctx.$t('report.contactPhone'),
                      placeholder: _ctx.$t('report.contactPhonePlaceholder'),
                      rules: [
                  { required: !$setup.reportForm.isAnonymous, message: _ctx.$t('report.contactPhoneRequired') },
                  { validator: $setup.validatePhone, message: _ctx.$t('report.phoneFormatError') }
                ],
                      type: "tel"
                    }, null, 8, ["modelValue", "label", "placeholder", "rules"])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_20, [
              _createVNode(_component_van_button, {
                round: "",
                block: "",
                type: "primary",
                "native-type": "submit",
                loading: $setup.submitting,
                class: "submit-button"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString($setup.submitting ? _ctx.$t('report.submitting') : _ctx.$t('report.submitReport')), 1)
                ]),
                _: 1
              }, 8, ["loading"])
            ])
          ]),
          _: 1
        }, 8, ["onSubmit"])
      ])
    ]),
    _createVNode(_component_van_dialog, {
      show: $setup.showSuccessDialog,
      "onUpdate:show": _cache[15] || (_cache[15] = ($event: any) => (($setup.showSuccessDialog) = $event)),
      title: _ctx.$t('report.submitSuccess'),
      "show-confirm-button": false,
      class: "success-dialog-container"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_21, [
          _createElementVNode("div", _hoisted_22, [
            _createVNode(_component_van_icon, {
              name: "checked",
              class: "success-icon"
            }),
            _createElementVNode("h3", null, _toDisplayString(_ctx.$t('report.thankYou')), 1)
          ]),
          _createElementVNode("div", _hoisted_23, [
            _createElementVNode("p", _hoisted_24, _toDisplayString(_ctx.$t('report.successMessage')), 1),
            ($setup.reportCode)
              ? (_openBlock(), _createElementBlock("p", _hoisted_25, [
                  _createTextVNode(_toDisplayString(_ctx.$t('report.caseNumber')) + ": ", 1),
                  _createElementVNode("strong", null, _toDisplayString($setup.reportCode), 1)
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_26, [
            _createElementVNode("h4", _hoisted_27, _toDisplayString(_ctx.$t('report.trackProgress')), 1),
            _createElementVNode("p", _hoisted_28, _toDisplayString(_ctx.$t('report.scanToTrack')), 1),
            _createElementVNode("div", _hoisted_29, [
              _createElementVNode("img", {
                src: $setup.reportQrCode,
                alt: _ctx.$t('report.progressQrAlt'),
                class: "qr-code"
              }, null, 8, _hoisted_30)
            ])
          ]),
          _createElementVNode("div", _hoisted_31, [
            _createVNode(_component_van_button, {
              type: "primary",
              class: "dialog-button primary-button",
              onClick: $setup.handleViewReport
            }, {
              default: _withCtx(() => [
                _createVNode(_component_van_icon, { name: "eye" }),
                _createTextVNode(" " + _toDisplayString(_ctx.$t('report.viewReport')), 1)
              ]),
              _: 1
            }, 8, ["onClick"])
          ])
        ])
      ]),
      _: 1
    }, 8, ["show", "title"])
  ]))
}